import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { ProjectPostDataAPI } from '../../../../Redux/SidebarMasterSlice/ProjectNameSlice';
import { WardNameDataDDL } from '../../../../Components/CommonDDL/WardNameDataDDL';
import { ProjectTypeDataDDL } from '../../../../Components/CommonDDL/ProjectTypeDataDDL';
import { RegExOnlyText } from '../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../Helper/AstricSign';


export default function ProjectNamePopup({ handleOnCloseClick, open, handleIsPost, rowData, Flag, DashProjectTypeId, ProjectTypeId }) {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()


    // const [rowData, setRowData] = useState(item)

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WardID : 1,
        Label: Flag === 'Update' ? rowData.wardName : "Select...",
    })

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
        Label: Flag === 'Update' ? rowData.projectType : "Select...",
    })

    const [ProjectName, setProjectName] = useState(Flag === 'Update' ? rowData.projectName : '')

    // console.log(Flag, EmployeeField)
    // const handleClearField = () => {

    //     if (Flag != 'Update') {
    //         setProjectName('')
    //     }
    // }

    const [IsOpen, setIsOpen] = useState(false)

    useEffect(() => {
        setProjectName(Flag === 'Update' ? rowData.projectName : '')
    }, [rowData, IsOpen])


    const [IsValidText, setIsValidText] = useState(false)
    const handleCheckText = (e) => {
        setProjectName(e.target.value)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    const handlePost = () => {
        const data = {

            M_ProjectID: Flag === 'Update' ? rowData.m_ProjectID : '0',
            M_ProjectType: DashProjectTypeId=="6" ? "WaterSupplyDistributionLine" : DashProjectTypeId == "1" ? "WaterSupply" : DashProjectTypeId == "7" ? "WTP" 
            : ProjectTypeId == "2" ? "Sewerage" : ProjectTypeId == "3" ? "STP" : ProjectTypeId == "4" ? "RoadWork" : ProjectTypeId == "8" ? "Electrical" : "Garden" ,
            ProjectName: ProjectName,
            M_WardID: WardName.ID,
            // M_ProjectTypeID: ProjectType.ID,
            M_ProjectTypeID: 0,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            // handleClearField: handleClearField,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(ProjectPostDataAPI({ data }))

    }

    return (
        <Popup open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}>
            <div className="area_pop modal-dialog modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Project Name</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">
                                <div className="col-12 col-lg-6 ">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        Flag={Flag}
                                        rowData={rowData}
                                        IsDisabled={true}
                                    />
                                </div>
                                {/* <div className="col-12 col-lg-6 ">
                                    <ProjectTypeDataDDL
                                        ProjectType={ProjectType}
                                        setProjectType={setProjectType}
                                        Flag={Flag}
                                        rowData={rowData}

                                    />
                                </div> */}
                                <div className="col-12 col-lg-6 ">
                                    <label for=""><b>Project Name <AstricSign /> </b></label>
                                    <input type="text" className="form-control"
                                        id="exampleInputEmail1" name='EmployeeName'
                                        aria-describedby="emailHelp"
                                        value={ProjectName}
                                        onChange={(e) => handleCheckText(e)}
                                    />
                                    {
                                        IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                    }
                                </div>
                            </div>

                            {/* <div className="mb-4 pt-4">
                                <div className="float-end">
                                    <span className="submit_btn"
                                        disabled={
                                            WardName.ID === 0 && ProjectType.ID === 0 && ProjectName === ''
                                        }
                                        onClick={handlePost}
                                    >{Flag === 'Update' ? 'Update' : 'Save'}</span>
                                    <span className=" cancel_btn ms-2" onClick={handleOnCloseClick} >Cancel</span>
                                </div>
                            </div> */}

                            <div className="col-12 col-lg-12 pt-lg-5">
                                <div className="btn-action d-flex justify-content-end">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            WardName.ID == 0 || ProjectName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </Popup >
    )

}